import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18VideoChat = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M11.917 2.75c.92 0 1.666.746 1.666 1.667v1.071l1.223-.61a1.46 1.46 0 0 1 1.888.529l.069.123c.08.162.13.337.148.517l.006.135v5.636a1.458 1.458 0 0 1-1.987 1.36l-.124-.055-1.223-.612v1.072c0 .92-.746 1.667-1.666 1.667H2.75c-.92 0-1.667-.746-1.667-1.667V4.417c0-.92.747-1.667 1.667-1.667zm0 1.25H2.75a.42.42 0 0 0-.41.342l-.007.075v9.166c0 .205.148.375.342.41L2.75 14h9.167a.42.42 0 0 0 .41-.342l.006-.075V4.417a.42.42 0 0 0-.341-.41zM4.75 5.924a.84.84 0 0 1 1.265-.072l.636.636a.84.84 0 0 1 .013 1.19.71.71 0 0 0 .012 1.004l1.198 1.199a.71.71 0 0 0 1.005.01.84.84 0 0 1 1.19.014l.635.636a.84.84 0 0 1-.072 1.265c-.96.674-2.274.549-3.117-.294L5.045 9.04c-.844-.843-.97-2.157-.298-3.11zm10.668.053-.053.019-1.666.833a.2.2 0 0 0-.107.129l-.009.057v3.97c0 .06.026.115.068.154l.048.032 1.666.834a.208.208 0 0 0 .294-.131l.008-.056V6.182a.208.208 0 0 0-.249-.205"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18VideoChat$1 = Svg18VideoChat;

export { Svg18VideoChat$1 as default };
